import moment from 'moment-timezone';
import { validateWebUrl } from 'appSrc/utils';
import { YOUTUBE_URI_REGEX, FACEBOOK_URI_REGEX } from 'appSrc/utils/video';

export function blockSetFactory ( blocks ) {
    blocks.forEach( ( block ) => {
        block.errors = {};
        block.st = moment.tz( block.start_time, 'America/Chicago' );
        block.et = moment.tz( block.end_time, 'America/Chicago' );

        // check video uris
        var video = block.video;
        if( !video[ 'uri' ] ) {
            block.errors[ 'video__uri' ] = 'Video Link is required';
        } else {
            if( !validateWebUrl( video[ 'uri' ] ) ) {
                block.errors[ 'video__uri' ] = 'Video Link is invalid';
            }else if( YOUTUBE_URI_REGEX.test( video[ 'uri' ] ) ) {
                video[ 'source' ] = 'youtube';
            } else if( FACEBOOK_URI_REGEX.test( video[ 'uri' ] ) ) {
                video[ 'source' ] = 'facebook';
            } else {
                block.errors[ 'video__uri' ] = 'Video Link doesn\'t match expected patterns';
            }
        }
    } );
    // sort the blocks
    blocks.sort( ( a, b ) => {
        return a.st.valueOf() - b.st.valueOf();
    } );

    var lastET = moment( 0 );
    // compare times to make sure there isn't any overlap
    blocks.forEach( ( block ) => {
        if( block.st.isBefore( lastET ) ) {
            block.errors[ 'start_time' ] = 'Start Time overlaps previous video';
        }
        lastET = block.et.clone();
    } );

    return blocks;
}
